import { useEffect, useState } from 'react';
import css from './StudentOverview.module.css';

import * as studentServices from '../../../../../services/studentServices';

import Table from '../../../_common/data/Table';
import ModalForm from '../../../_common/ModalForm';
import AddNewStudent from './AddNewStudent';

function StudentOverview() {
    const [students, setStudent] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        studentServices
            .getAll(page || 1)
            .then((result) => {
                setStudent((state) => result.data.sort((a, b) => b.ID.localeCompare(a.ID)) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (newData) => {
        setStudent((state) => [
            {
                ID: newData.studentNo,
                Name: (newData.studentFirstName + ' ' + newData.studentMidName + ' ' + newData.studentLastName).replace(
                    '  ',
                    ' '
                ),
                DoB: newData.studentDoB,
                PoB: newData.studentPoB,
                Mail: newData.studentEmail,
                Phone: newData.studentPhone,
            },
            ...state,
        ]);
    };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);
    
    //Provides the start of the link for the details
    const detailsTo = '/student/details/';

    return (
        <div className={css.main}>
            <div>
                <Table data={students} detailsTo={detailsTo} />
            </div>
            <div>
                <div>
                    <button onClick={toggleModal} className={css.button}>
                        +
                    </button>
                    <ModalForm showModal={showModal}>
                        <AddNewStudent data={students} onAdd={onAdd} toggleModal={toggleModal} />
                    </ModalForm>
                </div>
                <></>
            </div>
        </div>
    );
}

export default StudentOverview;
